export function balance(payload) {
  return {
    type: "BALANCE",
  };
}
export function setbalance(data) {
  return {
    type: "SET_BALANCE",
    payload: {
      ...data,
    },
  };
}

export function getBalance() {
  return {
    type: "BALANCE",
  };
}
